import { z } from 'zod';

export const onboardingWidgetSchema = z.object({
  number_of_ice: z.number().int().min(0).max(20),
  number_of_ev: z.number().int().min(0).max(20),
  residential: z.boolean(),
  referral_code: z.string().optional(),
});

export type IOnboardingWidgetState = z.infer<typeof onboardingWidgetSchema>;
